import { Row, Col, Divider } from 'antd';
import { Link } from 'react-router-dom';
import { InstagramOutlined, LinkedinOutlined, GoogleOutlined, TikTokOutlined, WhatsAppOutlined } from '@ant-design/icons';
import synteraLogo from '../assets/syntera-logo.png';

import { LEGAL_DOCUMENTS } from '../content/legalDocuments';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{
      background: '#f5efe4',
      borderTop: '1px solid rgba(24, 32, 45, 0.08)',
      padding: '48px 24px 24px',
      marginTop: 0,
    }}>
      <div className="page-shell">
        <Row gutter={[32, 32]} style={{ marginBottom: 32 }}>
          <Col xs={24} sm={12} md={6}>
            <img src={synteraLogo} alt="Syntera" style={{ width: 220, maxWidth: '100%', marginBottom: 12 }} />
            <p style={{ fontSize: 18, lineHeight: 1.6, color: '#2a3242', maxWidth: 300 }}>
              Sağlık ve güzellik sektörüne özel eğitim içerikleri, danışmanlık hizmetleri ve kurumsal gelişim çözümleriyle profesyonellerin yanında yer alır.
            </p>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <h4 style={{ marginBottom: 12 }}>Hızlı Bağlantılar</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 8 }}>
                <Link to="/" style={{ color: '#18202d', fontSize: 14 }}>Anasayfa</Link>
              </li>
              <li style={{ marginBottom: 8 }}>
                <Link to="/egitimlerimiz" style={{ color: '#18202d', fontSize: 14 }}>Eğitimlerimiz</Link>
              </li>
              <li style={{ marginBottom: 8 }}>
                <Link to="/akademilerimiz" style={{ color: '#18202d', fontSize: 14 }}>Akademilerimiz</Link>
              </li>
              <li style={{ marginBottom: 8 }}>
                <Link to="/danismanlik-konularimiz" style={{ color: '#18202d', fontSize: 14 }}>Danışmanlık Konularımız</Link>
              </li>
              <li style={{ marginBottom: 8 }}>
                <Link to="/egitimlerim" style={{ color: '#18202d', fontSize: 14 }}>Eğitimlerim</Link>
              </li>
              <li>
                <Link to="/iletisim" style={{ color: '#18202d', fontSize: 14 }}>İletişim</Link>
              </li>
            </ul>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <h4 style={{ marginBottom: 12 }}>Kurumsal</h4>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              <li style={{ marginBottom: 8 }}>
                <Link to="/hakkimizda" style={{ color: '#18202d', fontSize: 14 }}>Hakkımızda</Link>
              </li>
              <li style={{ marginBottom: 8 }}>
                <Link to="/danismanlik-konularimiz" style={{ color: '#18202d', fontSize: 14 }}>Danışmanlık Alanları</Link>
              </li>
              <li style={{ marginBottom: 8 }}>
                <Link to="/login" style={{ color: '#18202d', fontSize: 14 }}>Giriş Yap</Link>
              </li>
              <li>
                <Link to="/register" style={{ color: '#18202d', fontSize: 14 }}>Kayıt Ol</Link>
              </li>
            </ul>
          </Col>

          <Col xs={24} sm={12} md={6}>
            <h4 style={{ marginBottom: 12 }}>Sosyal Ağlar</h4>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 18, fontSize: 32 }}>
              <a href="https://www.instagram.com/syntera.tr/" target="_blank" rel="noopener noreferrer" style={{ color: '#18202d' }} aria-label="Instagram"><InstagramOutlined /></a>
              <a href="https://www.tiktok.com/@syntera.tr" target="_blank" rel="noopener noreferrer" style={{ color: '#18202d' }} aria-label="TikTok"><TikTokOutlined /></a>
              <a href="https://wa.me/905322832939" target="_blank" rel="noopener noreferrer" style={{ color: '#18202d' }} aria-label="WhatsApp"><WhatsAppOutlined /></a>
              <a href="https://www.google.com/search?q=Syntera+Eğitim+ve+Danışmanlık" target="_blank" rel="noopener noreferrer" style={{ color: '#18202d' }} aria-label="Google"><GoogleOutlined /></a>
              <a href="https://tr.linkedin.com/in/ozge-yuksel-babao%C4%9Flu-968bba16" target="_blank" rel="noopener noreferrer" style={{ color: '#18202d' }} aria-label="LinkedIn"><LinkedinOutlined /></a>
            </div>
          </Col>
        </Row>

        <Divider style={{ margin: '24px 0' }} />

        <Row justify="space-between" align="middle" style={{ flexWrap: 'wrap', gap: 16 }}>
          <Col>
            <p style={{ fontSize: 12, color: '#999', margin: 0 }}>
              © {currentYear} Syntera. Tüm hakları saklıdır.
            </p>
          </Col>
          <Col>
            <div style={{ display: 'flex', gap: 12, rowGap: 10, flexWrap: 'wrap', justifyContent: 'flex-end', fontSize: 12 }}>
              {LEGAL_DOCUMENTS.map((document) => (
                <Link key={document.slug} to={`/yasal/${document.slug}`} style={{ color: '#666' }}>
                  {document.shortTitle}
                </Link>
              ))}
            </div>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default Footer;